import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentCompanySupportWhatsApp_company$key } from './__generated__/PaymentCompanySupportWhatsApp_company.graphql.ts';
import PaymentCompanySupportLink from './PaymentCompanySupportLink.tsx';
import { paymentCompanySupportParsePhoneNumber } from './paymentCompanySupportParsePhoneNumber.ts';

import type { ReactNode } from 'react';

type PaymentCompanySupportPhoneProps = {
  company: PaymentCompanySupportWhatsApp_company$key;
};

const PaymentCompanySupportWhatsApp = (
  props: PaymentCompanySupportPhoneProps,
): ReactNode => {
  const { t } = useTranslation();

  const company = useFragment<PaymentCompanySupportWhatsApp_company$key>(
    graphql`
      fragment PaymentCompanySupportWhatsApp_company on Company {
        preferences {
          support {
            phone
          }
        }
      }
    `,
    props.company,
  );

  if (!company?.preferences?.support?.phone) {
    return;
  }

  const parsedPhone = paymentCompanySupportParsePhoneNumber(
    company.preferences.support.phone,
  );

  if (!parsedPhone) {
    return;
  }

  return (
    <PaymentCompanySupportLink
      title={t('Seller WhatsApp')}
      href={`https://wa.me/${company.preferences.support.phone}`}
      target='_blank'
      rel='noopener noreferrer'
    >
      {parsedPhone.formatNational()}
    </PaymentCompanySupportLink>
  );
};

export default PaymentCompanySupportWhatsApp;
